import React, { useContext } from "react";
import { ModalContext, ModalType } from "@src/components/modals/ModalController";
import { Box, Flex } from "@src/components/Boxes";
import { css } from "@emotion/react";
import Container from "@src/components/Container";
import styled from "@emotion/styled";
import Button from "@src/components/Button";
import Translate from "@src/components/translation/Translate";
import { FaPlay } from "react-icons/fa";
import { mediaQueries } from "@src/styles/theme";
import { graphql, useStaticQuery } from "gatsby";

const Text = styled("p")`
  color: rgba(255, 255, 255, 0.9);
  font-size: 18px;
  margin: 0 0 25px;
  max-width: 21em;
  z-index: 1;
  text-align: center;
`;

const Header = styled("h1")`
  color: #fff;
  font-size: 44px;
  font-weight: 800;
  line-height: 52px;
  margin: 0 0 5px;
  z-index: 1;
`;

const HeroVideoSection = () => {
  const data = useStaticQuery(graphql`
    query {
      hero: file(name: { eq: "reading-time" }) {
        publicURL
      }
      heroLeft: file(name: { eq: "header_bg_left" }) {
        publicURL
      }
      heroRight: file(name: { eq: "header_bg_right" }) {
        publicURL
      }
      directus {
        page_press {
          hero_video_url
          hero_image {
            id
            file {
              publicURL
            }
          }
        }
      }
    }
  `);

  const {
    heroLeft,
    heroRight,
    directus: { page_press: directusPagePress },
  } = data;

  const modalContext = useContext(ModalContext);

  function openVideoModal() {
    modalContext.showModal(ModalType.VideoModal, { youtubeID: directusPagePress.hero_video_url });
  }

  return (
    <Box
      as="section"
      css={css`
        position: relative;
        background: url(${heroRight.publicURL}) bottom right no-repeat #251039 !important;
        background-color: #251039;
        background-position: right bottom !important;
        background-repeat: no-repeat no-repeat !important;
        color: #fff;

        max-height: 300px;
        height: 100%;
        ${mediaQueries[0]} {
          max-height: 437px;
        }
      `}
    >
      <Container
        height={"100%"}
        css={css`
          background-image: url(${directusPagePress.hero_image.file.publicURL}), url(${heroLeft.publicURL});
          background-position: 30px center, top left;
          background-size: 355px auto, auto auto;
          ${mediaQueries[1]} {
            background-position: 50px, left center, top;
            background-size: auto;
          }
          background-repeat: no-repeat no-repeat;
        `}
      >
        <Flex
          flexDirection={"column"}
          alignItems="center"
          justifyContent={["start", "center"]}
          height="100%"
          width={["100%", "41%"]}
          marginLeft={[0, "50%"]}
          paddingY="3em"
          css={css`
            &:before {
              content: "";
              display: block;
              position: absolute;
              top: 0;
              bottom: 0;
              left: 0;
              right: 0;
              background: rgba(41, 19, 64, 0.66);
              ${mediaQueries[0]} {
                background-color: transparent;
              }
            }
          `}
        >
          <Header>
            <Translate path={"directus.page_press.hero_title"} />
          </Header>
          <Text>
            <Translate path={"directus.page_press.hero_subtitle"} />
          </Text>
          <Button big onClick={openVideoModal}>
            <Flex alignItems={"center"}>
              <FaPlay
                css={css`
                  margin-right: 10px;
                `}
              />
              <Translate path={"directus.page_press.hero_button_text"} />
            </Flex>
          </Button>
        </Flex>
      </Container>
    </Box>
  );
};

export default HeroVideoSection;
